<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";
import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";
// ルール設定
import * as rules from "vee-validate/dist/rules";
for (let rule in rules) {
  extend(rule, rules[rule]);
}
// 日本語化
import ja from "vee-validate/dist/locale/ja";
localize("ja", ja);

// 英字・数字混在のカスタムルール追加
extend("alpha_num_mix", {
  validate: (value) => {
    // 英字と数字が両方含まれているか
    return /[a-zA-Z]/.test(value) && /\d/.test(value);
  },
  message: "パスワードは英字と数字を両方含めてください",
});

export default {
  components: {
    Layout,
    PageHeader,
    VueLoading,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      tableData: [],
      title: "ユーザー管理",
      items: [
        {
          text: "User",
          href: "/",
        },
        {
          text: "ユーザー管理",
          active: true,
        },
      ],
      rolesList: [
        { value: "admin", text: "Admin" },
        { value: "user", text: "User" },
      ],
      selectedRole: "admin",
      schools: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      name: "",
      email: "",
      roles: "",
      school_code: "",
      password: "",
      password2: "",
      id: null,
      errors: [],
      selectAll: false,
      filterItems: [],
      filter: null,
      filterOn: ["name", "email", "school_code", "school_name"],
      fields: [
        {
          key: "checkbox",
          label: "",
          sortable: false,
        },
        {
          key: "school_code",
          label: "学校コード",
          sortable: true,
          tdClass: "minWidth100",
          thClass: "minWidth100",
        },
        {
          key: "school_name",
          label: "学校名",
          sortable: true,
          tdClass: "minWidth100",
          thClass: "minWidth100",
        },
        {
          key: "name",
          label: "氏名",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "email",
          label: "メールアドレス",
          sortable: true,
          tdClass: "minWidth200",
        },
        { key: "actions", label: "", sortable: false, tdClass: "minWidth100" },
      ],
      loading: false,
      mode: "list",
      preRegisterEmail: "",
      preRegisterSchoolCode: "",
      searchSchoolCode: "", // 学校コード検索用
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const roles = params.get("roles"); // パラメータ`roles`を取得

    if (roles == "admin") {
      this.rolesList = [
        { value: "admin", text: "Admin" },
        { value: "user", text: "User" },
      ];
      this.getUser("admin");
    } else if (roles == "user") {
      this.rolesList = [{ value: "user", text: "User" }];
      this.getUser("user");
    } else {
      // rolesパラメータが無効な場合はホームにリダイレクト
      window.location.href = "/";
      return;
    }

    this.selectedRole = roles;
    this.searchItems();
  },
  computed: {
    rows() {
      return this.filterItems.length;
    },
    rules() {
      if (this.mode == "add") {
        return {
          required: true,
          min: 8,
          confirmed: "confirm",
          alpha_num_mix: true, // 追加
        };
      } else {
        return {
          min: 8,
          confirmed: "confirm",
          alpha_num_mix: true, // 追加
        };
      }
    },
    filteredFields() {
      // selectedRoleがadminの場合、school_codeとschool_nameを除外
      if (this.selectedRole === "admin") {
        return this.fields.filter(
          (field) => field.key !== "school_code" && field.key !== "school_name"
        );
      }
      // それ以外の場合は全てのフィールドを表示
      return this.fields;
    },
    titleWithRole() {
      // 表示名を変換
      let roleLabel = "";
      if (this.selectedRole === "admin") {
        roleLabel = "管理者";
      } else if (this.selectedRole === "user") {
        roleLabel = "ユーザー";
      } else {
        roleLabel = this.selectedRole;
      }
      return `${this.title}（${roleLabel}）`;
    },
  },
  methods: {
    // 検索
    searchItems() {
      this.loading = true;
      // ログインユーザーがuserの場合、searchSchoolCodeに自分の学校コードをセット
      if (this.$store.state.roles === "user") {
        this.searchSchoolCode = this.$store.state.school_code;
      }
      // パラメータを組み立て
      let params = {
        roles: this.selectedRole,
      };
      // selectedRoleがuser
      if (this.selectedRole === "user") {
        params.school_code = this.searchSchoolCode;
      }
      axios
        .get("/api/users", { params })
        .then((response) => {
          this.loading = false;
          this.tableData = response.data.users.map((item) => {
            return {
              ...item,
              roles: item.roles ? item.roles : "",
              school_code: item.school_code ? item.school_code : "",
            };
          });
          this.schools = [
            { text: " ", value: null }, // 空白の項目をリストの先頭に追加
            ...response.data.schools.map((school) => ({
              text: school.school_code + " : " + school.school_name,
              value: school.school_code,
            })),
          ];
          this.filterItems = this.tableData;
          this.selectAll = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 削除
    deleteItems() {
      this.loading = true;
      let list = this.tableData.filter((item) => item.selected);
      let ids = [];
      list.forEach((item) => {
        ids.push(item.id);
      });
      axios
        .post("/api/users/delete", {
          ids: ids,
        })
        .then((response) => {
          this.loading = false;
          this.searchItems();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 追加
    add() {
      this.mode = "add";
      this.id = "new";
      this.name = "";
      this.email = "";
      this.roles = this.selectedRole;
      // 自分がuserの場合は自分の学校コードを初期値に
      if (this.$store.state.roles === "user") {
        this.school_code = this.$store.state.school_code;
      } else {
        this.school_code = "";
      }
      this.password = "";
      this.password2 = "";
    },
    // 仮登録
    addPreRegister() {
      this.mode = "pre-register";
      this.preRegisterEmail = "";
      this.preRegisterSchoolCode = "";
    },
    async submitPreRegister() {
      if (!this.preRegisterEmail) return;
      this.loading = true;
      try {
        await axios.post("/api/users/pre-register", {
          email: this.preRegisterEmail,
          school_code: this.preRegisterSchoolCode,
        });
        this.loading = false;
        this.mode = "list";
        this.searchItems();
      } catch (error) {
        this.loading = false;
        this.errorProcess(error);
      }
    },
    // 編集
    edit(item) {
      this.mode = "edit";
      this.id = item.id;
      this.name = item.name;
      this.email = item.email;
      this.roles = item.roles;
      this.school_code = item.school_code;
      this.password = "";
      this.password2 = "";
    },
    // 確定
    submit() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("roles", this.roles);
      formData.append("school_code", this.school_code);
      formData.append("password", this.password);
      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      this.loading = true;
      axios
        .post("/api/users/update", formData, config)
        .then((res) => {
          this.loading = false;
          console.log(formData);
          this.searchItems();
          this.mode = "list";
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    onFiltered(items) {
      console.log(items);
      this.filterItems = items;
    },
  },
  watch: {
    selectAll: function (newValue, oldValue) {
      this.filterItems.forEach((item) => {
        item.selected = this.selectAll;
      });
    },
  },
};
</script>
<style>
.flex {
  display: flex;
}

.box {
  width: 60px;
  flex-shrink: 0;
}

.minWidth100 {
  min-width: 100px;
  word-break: break-all;
}

.minWidth200 {
  min-width: 200px;
  word-break: break-all;
}

.minWidth300 {
  min-width: 300px;
  word-break: break-all;
}

.right {
  text-align: right;
}

.colorRed {
  color: red;
}

.table-hover tbody tr .colorRed {
  color: red;
}

.table-hover tbody tr:hover .colorRed {
  color: red;
}

.modal-mask {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<template>
  <Layout>
    <PageHeader :title="titleWithRole" :items="items" />
    <!-- リスト -->
    <div class="row" v-if="mode == 'list'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-sm-12 col-md-4" v-if="selectedRole === 'user'">
                <b-form-group label="学校コード" label-cols-sm="3">
                  <b-form-select
                    v-model="searchSchoolCode"
                    :options="schools"
                    @change="searchItems"
                    class="form-select"
                    :disabled="$store.state.roles === 'user'"
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <label class="ms-1 mb-0 pb-0">件数：{{ filterItems.length }}</label>
            </div>
            <hr class="mt-1 pt-0" />
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    表示&nbsp;
                    <b-form-select v-model="perPage" size="sm" class="form-select form-select-sm"
                      :options="pageOptions"></b-form-select>&nbsp;行
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="text-md-end">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    フィルタ:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive">
              <b-table striped hover :items="tableData" :fields="filteredFields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template v-slot:head(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="selectAll">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="item.selected" class="mr-1">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(actions)="{ item }">
                  <span>
                    <button class="btn btn-sm btn-outline-primary" @click="edit(item)" :disabled="item.pre == 1">
                      編集
                    </button>
                  </span>
                </template>
              </b-table>
            </div>
            <div class="row mb-3">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-12 mb-3">
                <div id="tickets-table_filter" class="text-md-end">
                  <button class="btn btn-danger me-2" type="button" v-b-modal.modal-delete>
                    削除
                  </button>
                  <button class="btn btn-primary me-2" type="button" @click="add">
                    追加
                  </button>
                  <button
                    class="btn btn-secondary"
                    type="button"
                    @click="addPreRegister"
                    v-if="$store.state.roles !== 'user'"
                  >
                    仮登録
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- 仮登録用フォーム -->
    <div class="row" v-if="mode == 'pre-register'">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">仮登録</h4>
            <ValidationObserver ref="preObs" v-slot="ObserverProps">
              <b-form>
                <div class="row">
                  <div class="col-lg-10">
                    <b-form-group label="学校名" label-cols-sm="3">
                      <ValidationProvider name="学校名" rules="required">
                        <div slot-scope="ProviderProps">
                          <b-form-select v-model="preRegisterSchoolCode" class="form-select" :options="schools"
                            style="width: 200px"></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="メールアドレス" label-cols-sm="3">
                      <ValidationProvider name="メールアドレス" rules="required|email">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="text" v-model="preRegisterEmail" autocomplete="off"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row mt-2">
                  <div>
                    <b-button class="me-2" variant="primary" :disabled="ObserverProps.invalid"
                      @click="submitPreRegister">確定</b-button>
                    <b-button variant="primary" @click="mode = 'list'">戻る</b-button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- 追加・編集 -->
    <div class="row" v-if="mode == 'add' || mode == 'edit'">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              {{ mode == "add" ? "新規登録" : "編集" }}
            </h4>
            <ValidationObserver ref="obs" v-slot="ObserverProps">
              <b-form>
                <div class="row">
                  <div class="col-lg-10">
                    <b-form-group label="学校名" label-cols-sm="3" v-if="selectedRole === 'user'">
                      <ValidationProvider name="学校名" :rules="selectedRole === 'user' ? 'required' : ''">
                        <div slot-scope="ProviderProps">
                          <b-form-select
                            v-model="school_code"
                            class="form-select"
                            :options="schools"
                            style="width: 200px"
                            :disabled="$store.state.roles === 'user'"
                          ></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="氏名" label-cols-sm="3">
                      <ValidationProvider name="氏名" rules="required">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="text" v-model="name" autocomplete="off"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="メールアドレス" label-cols-sm="3">
                      <ValidationProvider name="メールアドレス" rules="required|email">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="text" v-model="email" autocomplete="off"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="パスワード" label-cols-sm="3">
                      <ValidationProvider name="パスワード" :rules="rules">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="password" v-model="password" autocomplete="new-password"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="パスワード（確認）" label-cols-sm="3">
                      <ValidationProvider name="パスワード（確認）" rules="" vid="confirm">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="password" v-model="password2"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <!-- <b-form-group label="権限" label-cols-sm="3" v-if="selectedRole === 'admin'">
                      <ValidationProvider name="権限" rules="required">
                        <div slot-scope="ProviderProps">
                          <b-form-select v-model="roles" class="form-select" :options="rolesList"
                            style="width: 200px"></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group> -->
                  </div>
                </div>
                <div class="row mt-2">
                  <div>
                    <b-button class="me-2" variant="primary" :disabled="ObserverProps.invalid"
                      @click="submit">確定</b-button>
                    <b-button variant="primary" @click="mode = 'list'">戻る</b-button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!-- 削除 -->
    <b-modal id="modal-delete" title="確認" title-class="font-18" @ok="deleteItems">
      <p>選択されたデータを削除してよろしいですか？</p>
    </b-modal>
    <div v-if="loading" class="modal-mask">
      <vue-loading type="spiningDubbles" color="#eee" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
  </Layout>
</template>
